module.exports = "/_next/static/images/9d0ea0f35784ffcb140ed6cd5ce14fd3-open-graph-logo-large-br.png.webp";